/* istanbul ignore file */
export enum EventStatus {
  Draft = "draft",
  Published = "published",
  Deleted = "deleted",
  Cancelled = "cancelled",
  Postponed = "postponed"
}
